<!--
  @delhivery/auth header, rendered here (not the copy AuthModule auto-injects into <body>)
  so it's part of this view's change detection. Logo, title and the user menu come from
  the library; the controls below are projected into its otherComponent slot.
-->
<div class="app-header">
  <!-- Menu toggle sits outside the library header so it can be placed left of the logo -->
  <button
    type="button"
    class="header__toggle-menu"
    [attr.aria-label]="collapseSidebar ? 'Open menu' : 'Close menu'"
    [attr.aria-expanded]="!collapseSidebar"
    aria-controls="sidebar-wrapper"
    (click)="toggleSidebar()"
  >
    <i class="material-icons dlv-icon" [ngClass]="collapseSidebar ? '' : 'active'" aria-hidden="true">menu</i>
  </button>
  <lib-auth-header></lib-auth-header>
</div>

<ng-template #headerExtra>
  <div class="header-extra">
    <mat-form-field class="input-search">
      <input
        matInput
        placeholder="{{ 'header.enter' | translate }}{{ optionSelected }}"
        pattern="^([0-9A-Za-z_ -]+)(,[0-9A-Za-z_ -]+)*$"
        (keyup.enter)="callApi($event)"
      />
    </mat-form-field>

    <mat-form-field class="drop input-search-drop">
      <mat-select
        placeholder="{{ optionSelected }}"
        (selectionChange)="getValue($event, 2)"
      >
        <mat-option value="Waybills">Waybills</mat-option>
        <mat-option value="bags">Bags</mat-option>
        <mat-option value="hawb">HAWB</mat-option>
        <mat-option value="mawb">MAWB</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field class="drop">
      <mat-select
        [placeholder]="'header.selectLocation' | translate"
        (selectionChange)="getValue($event, 3)"
        [(value)]="selectedValue3"
      >
        @for (center of centersList; track center; let i = $index) {
          <mat-option value="{{ center.name }}">{{ center.name }}</mat-option>
        }
        <mat-option value="default">Default</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field class="drop">
      <mat-select
        [placeholder]="'header.selectLanguage' | translate"
        (selectionChange)="useLanguage(selectedValue4)"
        [(value)]="selectedValue4"
      >
        <mat-option value="en">English</mat-option>
        <mat-option value="cn">Chinese</mat-option>
      </mat-select>
    </mat-form-field>
  </div>
</ng-template>
<div>
  <div class="menu_visible content-wrapper" [class.sidebar-collapsed]="collapseSidebar" title>
    <div class="grey_background"></div>
    <!-- Collapse offset comes from #sidebar-wrapper.collapsed in styles.scss ($sidebar-width) -->
    <div
      id="sidebar-wrapper"
      [ngClass]="collapseSidebar ? 'collapsed' : ''"
    >
      <sidebar (messageEvent)="autoCloseSidebar($event)"></sidebar>
    </div>
    <div class="content-area margin-top18">
      <div class="container-fluid">
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>
</div>
